const targetCategory = () =>
  import('@/views/main/target/category-tagetory/category-tagetory.vue')
export default {
  path: '/main/target/targetCategory',
  name: 'targetCategory',
  component: targetCategory,
  children: []
}
